import homeImg from "../../assets/homeBarIcon/home.png";
import homeCheckedImg from "../../assets/homeBarIcon/home_checked.png";
import meImg from "../../assets/homeBarIcon/me.png";
import meCheckedImg from "../../assets/homeBarIcon/me_checked.png";
import messageImg from "../../assets/homeBarIcon/message.png";
import messageCheckedImg from "../../assets/homeBarIcon/message_checked.png";
import studyImg from "../../assets/homeBarIcon/study.png";
import studyedCheckedImg from "../../assets/homeBarIcon/study_checked.png";
// state
// 定义该模块所具有的全局属性
const state = {
  checkIndex: 0
}

// getters
const getters = {}

// mutations
const mutations = {
  //  设置vuex全局state中的checkIndex,homeBar的选中项index
  setMenuCheckIndex(state, index) {
    state.checkIndex = index
  }
}

// actions
const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/menu.js